import ExportDocument from './exportdocument'

export default ExportDocument